import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useRole } from 'hooks/useRole';

import { useGetUserInfoQuery } from 'store/api/strapiService/rewardSystemController';
import { userSelector } from 'store/slices/user';

import { isMediaAffiliate } from 'utils/roles';

import { REWARD_SYSTEM_TYPES } from 'components/config/rewardSystem';

export const useRewardSystemUser = () => {
  const { email } = useSelector(userSelector.getInfo) ?? {};

  const role = useRole();

  const mediaAffiliate = isMediaAffiliate(role);

  const type = useMemo(
    () =>
      mediaAffiliate ? REWARD_SYSTEM_TYPES.media : REWARD_SYSTEM_TYPES.b2b,
    [mediaAffiliate],
  );

  const { data, isLoading } = useGetUserInfoQuery(
    { email, type },
    { skip: !email },
  );

  const { documentId, isActive, termsAccepted, shopLink, companies } =
    data?.data?.[0] ?? {};

  return {
    userId: documentId,
    email,
    type,
    hasAccess: isActive,
    mediaAffiliate,
    termsAccepted,
    companyId: companies?.[0]?.documentId,
    shopLink,
    isLoading,
  };
};
